import { render, staticRenderFns } from "./OrganizationNotificationContact.vue?vue&type=template&id=08bbc929&scoped=true&"
import script from "./OrganizationNotificationContact.vue?vue&type=script&lang=js&"
export * from "./OrganizationNotificationContact.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationNotificationContact.vue?vue&type=style&index=0&id=08bbc929&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbc929",
  null
  
)

export default component.exports